<template>
    <span v-html="highlightedText"/>
</template>

<script>
export default {
    props: {
        text: String,
        highlight: String,
    },

    computed: {
        highlightedText() {
            if (this.highlight.trim().length === 0) {
                return this.text
            }

            let out = this.text
            for (let part of this.highlight.split(' ')) {
                let regex = new RegExp(part, 'i');
                let matches = this.text.match(regex);
                if (matches) {
                    out = out.split(regex).
                        join(`<u class="text-primary">${matches[0]}</u>`)
                }
            }

            return out
        },
    },
}
</script>
